module.exports = __webpack_public_path__ + "static/media/cloud-download.42de0d6c.svg";